/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LinkChanged } from '../../models/link-changed';

export interface GetLinkChangedEvents$Params {
}

export function getLinkChangedEvents(http: HttpClient, rootUrl: string, params?: GetLinkChangedEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<LinkChanged>> {
  const rb = new RequestBuilder(rootUrl, getLinkChangedEvents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/event-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LinkChanged>;
    })
  );
}

getLinkChangedEvents.PATH = '/routers/events/linkChanged';
